'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_HomePage$() {
}
export { $c_Lpresto_HomePage$ as $c_Lpresto_HomePage$ };
$p = $c_Lpresto_HomePage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_HomePage$;
/** @constructor */
function $h_Lpresto_HomePage$() {
}
export { $h_Lpresto_HomePage$ as $h_Lpresto_HomePage$ };
$h_Lpresto_HomePage$.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-421681106);
});
$p.l = (function() {
  return "HomePage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "HomePage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_HomePage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_HomePage$, "presto.HomePage$", ({
  KF: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_HomePage$ as $d_Lpresto_HomePage$ };
var $n_Lpresto_HomePage$;
function $m_Lpresto_HomePage$() {
  if ((!$n_Lpresto_HomePage$)) {
    $n_Lpresto_HomePage$ = new $c_Lpresto_HomePage$();
  }
  return $n_Lpresto_HomePage$;
}
export { $m_Lpresto_HomePage$ as $m_Lpresto_HomePage$ };
//# sourceMappingURL=presto.-Home-Page$.js.map
